<div class="gold-border">
  <ng-content></ng-content>
</div>
